/**
 * What to show for a request that failed: the server's own sentence where it sent one.
 *
 * `ApiError.message` puts the route and the code in front of the raw body, and the body is JSON
 * — so a refused rename naming `ADÉLA` arrived as `/tidy answered 400: {"error": "... ÉLA
 * ..."}`, because the server's `json.dumps` escapes every non-ASCII letter. `detail` is that
 * body already parsed, which is the half an editor can act on.
 *
 * Read off the error's shape rather than tested with `instanceof ApiError`, so this module
 * takes no runtime import of `~/api/client`. A file that replaces that module with a stub of
 * `api` alone has no `ApiError` export, and an `instanceof` against it throws inside the very
 * `catch` that was meant to say what went wrong.
 */
export function why(error: unknown): string {
  const detail: unknown = error instanceof Error ? (error as { detail?: unknown }).detail : undefined
  if (typeof detail === 'string') return detail
  return error instanceof Error ? error.message : String(error)
}
